// extracted by mini-css-extract-plugin
module.exports = {"sound":"style_sound__-0Yge","progress":"style_progress__3Vx3c","replay":"style_replay__5dYH6","replayEnabled":"style_replayEnabled__1Ggsv"};